import React, {useEffect} from 'react';
import Slider from "react-slick";
import Header from '../components/header';
import Footer from '../components/footer';
import ContactModal from '../components/contact-modal';

function Home() {

  const settings = {
    centerMode: true,
    centerPadding: '0px',
    arrows: false,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          centerMode: true,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          slidesToShow: 2
        }
      }
    ]
  };


  return (
    <>
      <div className="main-page-wrapper font-gordita">
        {/* Theme Main Menu */}
        <Header />

        {/* Hero Banner */}
        <div className="hero-banner-five" id="home">
          <div className="container">
            <div className="row">
              <div className="col-xl-10 col-lg-11 col-md-10 m-auto">
                <h1 className="font-recoleta hero-heading">
                  Intelligent <span>AI Solutions</span> for Your Data Streams
                </h1>
                <p className="hero-sub-heading">
                  Cybernate delivers real-time AI analytics for video, sensors, and data streams
                </p>
              </div>
            </div>
            <div className="d-sm-flex align-items-center justify-content-center button-group">
              {/* <a href="#" className="d-flex align-items-center ios-button">
                <img src="./assets/images/icon/cloud.svg" alt="" className="icon" />
                <div>
                  <span>Start with</span>
                  <strong>Cloud API</strong>
                </div>
              </a> */}
              {/* <a href="#" className="d-flex align-items-center windows-button">
                <img src="./assets/images/icon/hardware.svg" alt="" className="icon" />
                <div>
                  <span>Deploy on</span>
                  <strong>Your hardware</strong>
                </div>
              </a> */}

                 <a href="https://app.cybernate.ai" className="d-flex align-items-center windows-button">
                {/* <img src="./assets/images/icon/hardware.svg" alt="" className="icon" /> */}
                <div>
                  <span>Join now</span>
                  <strong>Start Free Trial</strong>
                </div>
              </a>
            </div>
            <p className="sing-in-call">
              Have questions?{" "}
              <a href="mailto:support@cybernate.ai"
              //  data-toggle="modal" data-target="#contactModal"
               >
                Contact us
              </a>
            </p>
          </div>
          <div className="img-gallery">
            <div className="container text-center">
              <div className="screen-container">
                <img
                  src="./assets/images/assets/screen1.png"
                  alt="Cybernate Dashboard"
                  className="main-screen"
                />
                <img
                  src="./assets/images/assets/screen_01.1.png"
                  alt="AI Detection"
                  className="shapes screen-one"
                />
                <img
                  src="./assets/images/assets/screen_01.2.png"
                  alt="Analytics"
                  className="shapes screen-two"
                />
              </div>
            </div>
          </div>
          <div className="partner-slider-two mt-110 md-mt-80">
            <div className="container">
              <p className="text-center">
                Over <span>10+</span> businesses leveraging Cybernate's AI solutions.
              </p>
              <div className="partnerSliderTwo">
                <Slider {...settings}>
                    <div className="item">
                    <div className="img-meta d-flex align-items-center justify-content-center">
                      <img src="./assets/images/logo/frontdoors.png" height={50} alt="" />
                    </div>
                  </div>


                  <div className="item">
                    <div className="img-meta d-flex align-items-center justify-content-center">
                      <img src="./assets/images/logo/watever.png"  height={50} alt="" />
                    </div>
                  </div>
               
                
                     <div className="item">
                    <div className="img-meta d-flex align-items-center justify-content-center">
                      <img src="./assets/images/logo/Logo.svg"  height={50} alt="" />
                    </div>
                  </div>
                  {/* <div className="item">
                    <div className="img-meta d-flex align-items-center justify-content-center">
                      <img src="./assets/images/logo/logo-15.png" alt="" />
                    </div>
                  </div>
                  <div className="item">
                    <div className="img-meta d-flex align-items-center justify-content-center">
                      <img src="./assets/images/logo/logo-16.png" alt="" />
                    </div>
                  </div>
                  <div className="item">
                    <div className="img-meta d-flex align-items-center justify-content-center">
                      <img src="./assets/images/logo/logo-14.png" alt="" />
                    </div>
                  </div>
                  <div className="item">
                    <div className="img-meta d-flex align-items-center justify-content-center">
                      <img src="./assets/images/logo/logo-13.png" alt="" />
                    </div>
                  </div> */}
                </Slider>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="fancy-feature-ten mt-100 md-mt-70" id="features">
          <div className="bg-wrapper">
            <div className="container">
              <div className="row justify-content-between align-items-center">
                <div
                  className="col-md-6"
                  data-aos="fade-right"
                  data-aos-duration={1200}
                >
                  <div className="title-style-six">
                    <h2>
                      Core <span>Features</span> of Cybernate
                    </h2>
                  </div>
                </div>
                <div
                  className="col-lg-5 col-md-6"
                  data-aos="fade-left"
                  data-aos-duration={1200}
                >
                  <p className="sub-text pt-30 pb-30">
                    Advanced AI solutions that transform your video streams and sensor data into actionable intelligence.
                  </p>
                </div>
              </div>
              <div className="row justify-content-center mt-35 md-mt-20">
                <div
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration={1200}
                >
                  <div className="block-style-fifteen mt-40">
                    <div
                      className="icon d-flex align-items-center justify-content-center"
                      style={{ background: "#FFEBDB" }}
                    >
                      <img src="./assets/images/icon/68.svg" alt="" />
                    </div>
                    <h3>Secure & Private</h3>
                    <p>End-to-end encryption with on-premises deployment options for sensitive data</p>
                    <a href="#" className="mt-30">
                      <img src="./assets/images/icon/69.svg" alt="" />
                    </a>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration={1200}
                  data-aos-delay={100}
                >
                  <div className="block-style-fifteen mt-40">
                    <div
                      className="icon d-flex align-items-center justify-content-center"
                      style={{ background: "#E0F8F8" }}
                    >
                      <img src="./assets/images/icon/67.svg" alt="" />
                    </div>
                    <h3>Highly Customizable</h3>
                    <p>Tailor AI models to your specific detection and analytics requirements</p>
                    <a href="#" className="mt-30">
                      <img src="./assets/images/icon/69.svg" alt="" />
                    </a>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration={1200}
                  data-aos-delay={200}
                >
                  <div className="block-style-fifteen mt-40">
                    <div
                      className="icon d-flex align-items-center justify-content-center"
                      style={{ background: "#F7EDFF" }}
                    >
                      <img src="./assets/images/icon/69.svg" alt="" />
                    </div>
                    <h3>Real-time Analysis</h3>
                    <p>Process video and sensor data with millisecond latency for immediate insights</p>
                    <a href="#" className="mt-30">
                      <img src="./assets/images/icon/69.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Counter Section */}
        <div className="counter-style-two mt-150 md-mt-60">
          <div className="border-bottom">
            <div className="container">
              <div className="row justify-content-center">
                <div
                  className="col-lg-4 col-sm-6"
                  data-aos="fade-up"
                  data-aos-duration={1200}
                >
                  <div className="counter-box-four">
                    <h2 className="number">
                      <span
                        className="timer"
                        data-from={0}
                        data-to={99.9}
                        data-speed={1500}
                        data-refresh-interval={5}
                      >
                        99.9
                      </span>
                      %
                    </h2>
                    <p>Accuracy on detection tasks</p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-sm-6"
                  data-aos="fade-up"
                  data-aos-duration={1200}
                  data-aos-delay={100}
                >
                  <div className="counter-box-four">
                    <h2 className="number">
                      <span
                        className="timer"
                        data-from={0}
                        data-to={50}
                        data-speed={1200}
                        data-refresh-interval={5}
                      >
                        50
                      </span>
                      ms
                    </h2>
                    <p>Average processing latency</p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-sm-6"
                  data-aos="fade-up"
                  data-aos-duration={1200}
                  data-aos-delay={200}
                >
                  <div className="counter-box-four">
                    <h2 className="number">
                      <span
                        className="timer"
                        data-from={0}
                        data-to={500}
                        data-speed={1200}
                        data-refresh-interval={5}
                      >
                        500
                      </span>
                      +
                    </h2>
                    <p>Active business clients</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Use Cases */}
        <div className="fancy-feature-eleven mt-130 md-mt-80" id="use-cases">
          <div className="inner-container">
            <div className="container">
              <div className="row">
                <div className="col-xl-8 col-lg-10 col-md-9 m-auto">
                  <div className="title-style-six text-center">
                    <h6>Use Cases</h6>
                    <h2>
                      How <span>Cybernate</span> Drives Business Value
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="block-style-sixteen" style={{ background: "#EBF3F1" }}>
              <div className="container">
                <div className="row">
                  <div
                    className="col-xl-5 col-lg-6"
                    data-aos="fade-right"
                    data-aos-duration={1200}
                  >
                    <div
                      className="icon d-flex align-items-center justify-content-center"
                      style={{ background: "#DEEAE7" }}
                    >
                      <img src="./assets/images/icon/75.svg" alt="" />
                    </div>
                    <h3 className="title">Video Analytics & Detection</h3>
                    <p>
                      Transform any camera feed into an intelligent monitoring system with real-time object detection, people counting, and behavioral analysis.
                    </p>
                    <a href="#">
                      <img src="./assets/images/icon/72.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <img
                src="./assets/images/assets/video.jpg"
                alt="Video Analytics"
                className="shapes screen-one"
              />
            </div>
            <div className="block-style-sixteen" style={{ background: "#EDF3F9" }}>
              <div className="container">
                <div className="row">
                  <div
                    className="col-xl-5 col-lg-6 ml-auto"
                    data-aos="fade-left"
                    data-aos-duration={1200}
                  >
                    <div
                      className="icon d-flex align-items-center justify-content-center"
                      style={{ background: "#E1E7ED" }}
                    >
                      <img src="./assets/images/icon/74.svg" alt="" />
                    </div>
                    <h3 className="title">Sensor Data Intelligence</h3>
                    <p>
                      Extract meaningful patterns and insights from IoT sensor networks with advanced anomaly detection and predictive analytics.
                    </p>
                    <a href="#">
                      <img src="./assets/images/icon/72.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <img
                src="./assets/images/assets/sensor.jpg"
                alt="Sensor Analytics"
                className="shapes screen-two"
              />
            </div>
            <div className="block-style-sixteen" style={{ background: "#F9F1EF" }}>
              <div className="container">
                <div className="row">
                  <div
                    className="col-xl-5 col-lg-6"
                    data-aos="fade-right"
                    data-aos-duration={1200}
                  >
                    <div
                      className="icon d-flex align-items-center justify-content-center"
                      style={{ background: "#EDE5E3" }}
                    >
                      <img src="./assets/images/icon/73.svg" alt="" />
                    </div>
                    <h3 className="title">Custom API Integration</h3>
                    <p>
                      Seamlessly integrate Cybernate's AI capabilities into your existing systems and workflows with our flexible API solutions.
                    </p>
                    <a href="#">
                      <img src="./assets/images/icon/72.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <img
                src="./assets/images/assets/doc.jpg"
                alt="API Integration"
                className="shapes screen-three"
              />
            </div>
          </div>
        </div>

        {/* Call-to-Action Banner */}
        <div className="fancy-short-banner-six mt-150 md-mt-80">
          <img src="./assets/images/shape/143.svg" alt="" className="shapes shape-one" />
          <div className="container">
            <div className="row">
              <div
                className="col-xl-9 col-lg-11 m-auto"
                data-aos="fade-up"
                data-aos-duration={1200}
              >
                <div className="title-style-six text-center">
                  <h2>
                    Ready to transform your data? <br />
                    <span>Start a free trial</span> today.
                  </h2>
                </div>
              </div>
            </div>
            <p data-aos="fade-up" data-aos-duration={1200} data-aos-delay={100}>
              No commitment required — flexible monthly plans with enterprise options available.
            </p>
            <a
              href="https://app.cybernate.ai"
              className="theme-btn-seven"
              data-toggle="modal"
              data-target="#contactModal"
              data-aos="fade-up"
              data-aos-duration={1200}
              data-aos-delay={150}
            >
              Start Free Trial
            </a>
          </div>
        </div>
        
        {/* Footer */}
        <Footer />
        
        {/* Contact Modal */}
        <ContactModal />
        
        {/* Scroll Top Button */}
        <button className="scroll-top">
          <i className="fa fa-angle-up" aria-hidden="true" />
        </button>
      </div>
    </>
  );
}



export default Home;